// Libs
import React, { useState, useEffect } from 'react';

// Own Libs

//Api
import { getCrfFechamentoExecutiveSummary } from '@app/api/crf/crffechamento';
import { CrfRelatorioCapexManeger } from '@app/api/crf/crfRelatorioCicloorcamentario';

//Files
import CapexManagementSumary from '@app/views/crf/Modulo/ContaResultado/Dashboard/Graficos/capexManagementSumary';
import CapexManagement from '@app/views/crf/Modulo/ContaResultado/Dashboard/Graficos/capexManagement';
import CapexManagementGrafico from '@app/views/crf/Modulo/ContaResultado/Dashboard/Graficos/capexManagementGrafico';

//Utils

interface FechamentoExecutiveSummaryProps {
  fechamentoId: string;
}

const CrfFechamentoExecutiveSummary = ({ fechamentoId }: FechamentoExecutiveSummaryProps) => {
  const [relatorio, setRelatorio] = useState<CrfRelatorioCapexManeger>();

  useEffect(() => {
    if (fechamentoId) {
      getCrfFechamentoExecutiveSummary(fechamentoId).then(data => {
        if (data) setRelatorio(data);
      });
    }
  }, [fechamentoId]);

  return (
    <>
      {relatorio ? (
        <>
          <CapexManagementSumary data={relatorio} />
          <CapexManagementGrafico data={relatorio} />
          <CapexManagement data={relatorio} />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default CrfFechamentoExecutiveSummary;
